import { useFrontendConfigContext as nn } from "../../../config-lib/contexts/FrontendConfigContext.js";
import { CurrencyTokenType as U } from "../../../currency-lib/constants/currency.js";
import "../../../currency-lib/contexts/CurrencyContext.js";
import "../../../currency-lib/deserialize/yup/currency.js";
import tn from "../../../currency-lib/hooks/graphql/useGetCurrencyInfo.js";
import "@apollo/client";
import "../../../currency-lib/graphql/query/getOffChainTokenBalances.js";
import * as d from "ramda";
import { useMemo as en, useCallback as s } from "react";
import "../../../currency-lib/hooks/graphql/useGetTokenPriceToUSD.js";
import { ChainNetworkType as q } from "../../constants/chain.js";
import { ERROR_CODE as h } from "../../constants/error.js";
import { WalletType as l, WAGMI_RECENT_CONNECTOR_ID as on, WalletExtensionRdns as T } from "../../constants/web3.js";
import { useConfigContext as cn } from "../../contexts/config/ConfigContext.js";
import { CustomError as w } from "../../errors/customError.js";
import rn from "../generic/useChainSwitcher.js";
import { toWei as sn, fromWei as an } from "../../util/erc20/index.js";
import { getConnectors as R, disconnect as D, getAccount as k, getBalance as ln, readContract as un, getConnections as $, switchAccount as fn, reconnect as F, connect as v, signTypedData as dn, signMessage as wn } from "@wagmi/core";
import { erc20Abi as gn, parseUnits as mn, formatUnits as hn } from "viem";
const Cn = {
  toWei: (g, C = 18) => mn(g, C),
  fromWei: (g, C = 18) => hn(g, C)
}, p = (g) => {
  switch (g) {
    case l.Metamask:
      return T.Metamask;
    case l.Okx:
      return T.Okx;
    case l.Ronin:
      return T.Ronin;
    case l.RoninMobile:
    case l.WalletConnect:
      return T.WalletConnect;
    default:
      throw new w(`Invalid wallet type ${g}`);
  }
}, xn = () => {
  var B;
  const {
    config: g
  } = cn(), {
    waitConfig: C
  } = nn(), {
    fetch: b
  } = tn(), f = (B = g.web3) == null ? void 0 : B.wagmiConfig, I = en(() => d.isNotNil(f) ? R(f) : [], [f]), {
    getChainConfigs: G,
    getChainIdByType: M,
    getChainIdByWalletType: S,
    detectWalletType: N
  } = rn(), r = s(() => {
    if (d.isNil(f))
      throw new w("Wagmi config cannot be null, if you call useWeb3 function", h.CONTRACT.WAGMI_CONFIG_IS_NULL);
    return f;
  }, [f]), O = s(async () => {
    const n = r();
    await D(n);
  }, [r]), W = s(async (n) => {
    const t = r();
    let o;
    if (n) {
      const c = R(t).find((u) => u.id === p(n));
      if (!c)
        return !0;
      o = await (c == null ? void 0 : c.getChainId());
    } else {
      const i = k(t);
      if (!i.isConnected || !i.chainId)
        return !0;
      o = i.chainId;
    }
    const e = G(), a = d.pluck("chainId", e);
    return d.includes(o, a);
  }, [G, r]), Y = s(async (n) => {
    if (!await W(n))
      throw new w("Wrong network", h.LOGIN.WRONG_NETWORK);
  }, [W]), P = s(async (n) => {
    const t = r(), o = await C(), e = await b((o == null ? void 0 : o.supportToken.allTokens.onChain) || []), a = d.values(e || {});
    let i = [0, 0];
    const c = d.map((u) => ({
      functionName: "balanceOf",
      address: (u == null ? void 0 : u.address) || "",
      abi: gn,
      args: [n]
    }), a);
    try {
      const u = await ln(t, {
        address: n
      }), X = await Promise.allSettled(d.map((m) => un(t, m), c));
      i = d.map((m) => m.status === "fulfilled" ? m.value : 0, X);
      let E = {};
      return a.forEach((m, Z) => {
        E = d.assoc((m == null ? void 0 : m.type) || U.Unspecified, String(i[Z] || "0"), E);
      }), {
        ...E,
        [U.Ron]: String(u.value || "0")
      };
    } catch (u) {
      return console.error(u), {};
    }
  }, [b, r, C]), y = s((n = N()) => {
    if (typeof window > "u")
      return !1;
    switch (n) {
      case l.WalletConnect:
      case l.RoninMobile:
        return !0;
      case l.Ronin:
        return window.ronin !== void 0;
      case l.Okx:
        return window.okxwallet !== void 0;
      case l.Metamask:
        return window.ethereum !== void 0;
      default:
        return !1;
    }
  }, [N]), K = s(async ({
    walletType: n,
    networkType: t
  }) => {
    const o = r(), a = $(o).find((c) => c.connector.id === p(n));
    if (a)
      return await fn(o, {
        connector: a.connector
      }), await F(o, {
        connectors: [a.connector]
      }), {
        address: a.accounts[0],
        chainId: a.chainId
      };
    const i = I.find((c) => c.id === p(n));
    if (!i)
      throw new w(`Connector not found for wallet type ${n}`, h.LOGIN.NOT_YET_INSTALL_WALLET);
    try {
      const {
        accounts: c,
        chainId: u
      } = await v(o, {
        connector: i,
        chainId: M(t)
      });
      return {
        address: c[0],
        chainId: u
      };
    } catch (c) {
      const u = c;
      throw c instanceof w ? c : new w(`fail to connect wallet, reason: ${u.message}`, h.LOGIN.CANNOT_CONNECT_WALLET);
    }
  }, [r, I, M]), A = s(async () => {
    const n = r();
    try {
      const t = (localStorage.getItem(on) || "").replace(/['"]+/g, ""), e = R(n).find((c) => c.id === t);
      if (!e) return !1;
      const {
        accounts: a
      } = await v(n, {
        connector: e,
        chainId: await (e == null ? void 0 : e.getChainId())
      });
      return a.length !== 0;
    } catch {
      return !1;
    }
  }, [r]), x = s((n) => I.find((o) => o.id === p(n)), [I]), L = s((n, t = []) => {
    if (t.length === 0) {
      const e = N();
      if (e === l.WalletConnect || e === l.RoninMobile)
        return;
      t = n === q.Ronin ? [l.Ronin, l.Okx] : [l.Metamask];
    }
    if (!t.some((e) => y(e)))
      throw new w("Wallet not installed", h.LOGIN.NOT_YET_INSTALL_WALLET);
  }, [N, y]), j = s(async (n) => {
    const t = r();
    return L(q.Ronin), await A(), dn(t, n);
  }, [r, A, L]), z = s(async (n, t) => {
    const o = r();
    try {
      let e;
      if (t) {
        if (!y(t))
          throw new w(`Connector not found for wallet type ${t}`, h.LOGIN.NOT_YET_INSTALL_WALLET);
        e = x(t);
      }
      return !k(o).isConnected && e && await v(o, {
        connector: e
      }), await wn(o, {
        connector: e,
        message: n
      });
    } catch (e) {
      const a = e;
      throw O(), e instanceof w ? e : new w(`fail to sign signature, reason: ${a.message}`, h.LOGIN.CANNOT_SIGN_SIGNATURE);
    }
  }, [r, y, x, O]), _ = s(async (n, t) => {
    const o = r(), e = await W(n), i = R(o).find((c) => c.id === p(n));
    if (!i)
      return !1;
    try {
      return !e && i.switchChain && await i.switchChain({
        chainId: t
      }), !0;
    } catch (c) {
      return console.error(c), !1;
    }
  }, [r, W]), H = s(async () => {
    const n = N(), t = S(n);
    try {
      return await _(n, t), !0;
    } catch (o) {
      return console.error(o), !1;
    }
  }, [N, S, _]), J = s(async () => d.isNotNil(f) ? (await F(f), k(f)) : {
    address: void 0,
    addresses: void 0,
    chain: void 0,
    chainId: void 0,
    connector: void 0,
    isConnected: !1,
    isReconnecting: !1,
    isConnecting: !1,
    isDisconnected: !0,
    status: "disconnected"
  }, [f]), Q = s(() => {
    const n = r();
    return $(n);
  }, [r]), V = s((n) => {
    const t = r();
    return D(t, {
      connector: n
    });
  }, [r]);
  return {
    cleanSession: O,
    correctNetwork: W,
    getBalances: P,
    signRequest: z,
    switchNetworkAndRequestAddress: _,
    toWei: sn,
    fromWei: an,
    walletInstalled: y,
    web3Utils: Cn,
    connectWallet: K,
    switchToRequriedNetwork: H,
    manualReconnect: A,
    getWalletRdnsFromWalletType: p,
    connectors: I,
    getWalletAccount: J,
    validateNetwork: Y,
    validateWalletInstalled: L,
    sign712TypedData: j,
    getWalletConnections: Q,
    disconnectWallet: V,
    wagmiConfig: f
  };
};
export {
  xn as default
};
//# sourceMappingURL=useWeb3.js.map
